import React, { Component } from "react";
import { connect } from "react-redux";
//IMPORT COMPONENT
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import TextField                             from "material-ui/TextField";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";
import {Step, StepButton, StepConnector, StepContent, StepLabel, Stepper} from "material-ui/Stepper";
import Paper        from "material-ui/Paper";
//ICON
import IconWord         from "material-ui/svg-icons/av/library-books"
import IconArrowBack    from "material-ui/svg-icons/navigation/arrow-back"
import IconArrowForward from "material-ui/svg-icons/navigation/arrow-forward"
import IconHome         from "material-ui/svg-icons/action/home";
import IconCheck        from "material-ui/svg-icons/navigation/check";
//ACTIONS
import { checkUsername, checkEmailService } from "../Actions/Action_ServiceRequest_CheckValue";
import { paymentConfig, paymentPrices } from "../Actions/Action_ServiceRequest_Pagamento";
import { registerCloud, registerPro } from "../Actions/Action_ServiceRequest_Registrazione";
//Utils
import * as ROLES       from "../Utils/Roles_Types.js";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as STYLES from "../Utils/Styles.js";
import {Root} from "../Utils/Strings/Route";

import "../CSS/style_registrazione.css";
import { LABEL_Enter_Username, LABEL_Username, LABEL_PasswordNotEquals, LABEL_Enter_Password, LABEL_Password, LABEL_PasswordOKConfirm, LABEL_Required, LABEL_BusinessName,
         LABEL_Enter_City, LABEL_Enter_Email, LABEL_Enter_District, LABEL_Enter_Cap, LABEL_Enter_Piva, LABEL_Enter_BusinessName,
        LABEL_Email, LABEL_City,LABEL_Invalid_Piva,LABEL_ChooseVersione,  LABEL_Invalid_Cap, LABEL_Piva, LABEL_Cap,LABEL_Invalid_Email,  LABEL_District, LABEL_Address, LABEL_Enter_Address } from "../Utils/Strings/Labels";
import { checkEmail, checkCap, checkNull, checkPivaForm, checkEmailForm, checkCapForm , checkPassword, checkUserLanguage} from "../Utils/Check_Value";
import PaypalExpressBtn from "react-paypal-express-checkout";

const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

const styles = {
  pageContainer : {
    height     : "100vh",
    width      : "100%",
    background : "none",
    overflowY  : "auto"
  },
  headerContainer : {
    paddingTop : "2%",
    width      : "60%",
    margin     : "auto",
  },
  formContainer : {
    width          : "100%",
    marginTop      : "100px",
    margin         : "auto",
    paddingBottom  : "10%"
  },
  navButton : {
    position       : "absolute",
    background     : "trasparent",
    height         : "10%",
    bottom         : "0",
    zIndex         : "9999",
    width          : "100%",
    alignItems     : "center",
    justifyContent : "center",
    display        : "flex",
    display        : "flex",
    flexDirection  : "column",
  },
  paper : {
      width: "500px",
      paddingTop    : "25px",
      paddingBottom: "35px",
      margin: "auto"
  },
  paperTitle : {
    marginTop     : "20px",
    marginBottom  : "20px",
    width         : "100%",
    heigth        : "100%",
    backgroud     : "red",
    textAlign     : "center",
    textTransform : "uppercase",
    fontWeight    : "bold",
    fontSize      : "25px"
  },
  inputContainer : {
    width: "75%",
    margin: "auto"
  }
}

class Registrazione extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep : 0,
      userData : {
        username        : "",
        password        : "",
        confirmPassword : "",
        email           : ""
      },
      invoiceData : {
        ragioneSociale : "",
        piva : "", 
        indirizzo : "",
        email : "",
        citta : "",
        provincia : ""
      },
      paid : {
        success: false,
        error  : false,
        toDo   : true
      },
      payment : null,
      money : {
        currency : 'EUR', //'USD'    , // or you can set this value from your props or state
        total    : 0.01 , // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout
        selected : false,
        obj      : null
      }
    }
  }

  steps = ['Dati Utente', 'Dati Fatturazione', 'Pagamento'];

  nextStep = () => {
    var step        = this.state.activeStep;
    var userData    = this.state.userData;
    var invoiceData = this.state.invoiceData;
    var flag        = true;
    
    switch(step){
      case 0: 
              //Trimmo le due password e username
              userData.username = userData.username.trim();
              userData.password = userData.password.trim();
              userData.confirmPassword = userData.confirmPassword.trim();
              //USERNAME
              if( this.props.usernameError !== null && typeof this.props.usernameError !== 'undefined'){
                flag = false;
                userData.usernameError = null;
              }else if( checkNull(userData.username) ){
                userData.usernameError = LABEL_Required[USERLANGUAGE];
                flag = false;
              }else userData.usernameError = null;
              //EMAIL
              if( this.props.userEmailError !== null && typeof this.props.userEmailError !== 'undefined'){
                flag = false;
                userData.emailError = null;
              }else if( checkNull(userData.email) ){
                userData.emailError = LABEL_Required[USERLANGUAGE];
                flag = false;
              }else userData.emailError = null;
              //PASSWORD
              if( checkNull(userData.password) ){
                userData.passwordError = LABEL_Required[USERLANGUAGE];
                flag = false;
              }else userData.passwordError = null;
              //CONFIRM PASSWORD
              if( checkNull(userData.confirmPassword) ){
                userData.confirmPasswordError = LABEL_Required[USERLANGUAGE];
                flag = false;
              }else userData.confirmPasswordError = null;
              //CHECH PASSWORD 
              if(!flag) break;
              if( userData.password != userData.confirmPassword ){
                userData.confirmPasswordError = LABEL_PasswordNotEquals[USERLANGUAGE];
                userData.passwordError        = LABEL_PasswordNotEquals[USERLANGUAGE];
                flag = false;
              }else{
                var err = checkPassword(userData.password);
                userData.confirmPasswordError = userData.passwordError = err;
                if( err != null ) flag = false;
              }
              break;
      case 1: 
              //Ragione Sociale 
              if( checkNull(invoiceData.ragioneSociale) ){
                flag = false;
                invoiceData.ragioneSocialeError = LABEL_Required[USERLANGUAGE];
              }else invoiceData.ragioneSocialeError = null;
              //Piva
              invoiceData.pivaError = checkPivaForm(invoiceData.piva);
                if(invoiceData.pivaError != null) flag = false;
              //Indirizzo
              if( checkNull(invoiceData.indirizzo) ){
                flag = false;
                invoiceData.indirizzoError = LABEL_Required[USERLANGUAGE];
              }else invoiceData.indirizzoError = null;
              //citta
              if( checkNull(invoiceData.citta) ){
                flag = false;
                invoiceData.cittaError = LABEL_Required[USERLANGUAGE];
              }else invoiceData.cittaError = null;
              //provincia
              if( checkNull(invoiceData.provincia) ){
                flag = false;
                invoiceData.provinciaError = LABEL_Required[USERLANGUAGE];
              }else invoiceData.provinciaError = null;
              //cap
              invoiceData.capError = checkCapForm(invoiceData.cap);
                if( invoiceData.capError != null ) flag = false;
              //EMAIL
              invoiceData.emailError = checkEmailForm(invoiceData.email);
              if (invoiceData.emailError != null) flag = false;
              break;
      case 2: 
              if(this.state.paid.success){ // ti mando alla pagina di login
                PAGESSWITCH.gotoPageWithParams(Root);
              }
      default: 
              flag = false;
              break;
    }
    if(flag) step++;
    this.setState({activeStep: step});
  };

  backStep = () => {
    var step = this.state.activeStep;
    step--;
    this.setState({activeStep: step});
  };

  onFormTextChange = (object, subObject, value) => {
    var obj        = this.state[object] || {};
    obj[subObject] = value;
    this.setState({[obj]: obj});
    if(subObject === "username" && obj["username"] !== null ){
      this.props.dispatch(checkUsername(obj[subObject]));
    }
    if(object === "userData" && subObject === "email" && obj["email"] != null ){
      this.props.dispatch(checkEmailService(obj[subObject]));
    }
  }

  onPaymentError = err =>{
    var paid  = this.state.paid;
    paid.toDo    = false;
    paid.success = false;
    paid.erro    = true;
    this.setState({paid: paid});
  }

  onPaymentSuccess = payment =>{
    var paid = this.state.paid;
    paid.toDo    = false;
    paid.success = true;

    this.setState({paid: paid, payment : payment});

    if(this.state.money.Versione === "BilApp Cloud"){
      this.props.dispatch(registerCloud(this.state.userData, this.state.invoiceData, payment));
    }else{
      this.props.dispatch(registerPro(this.state.userData, this.state.invoiceData, payment));
    }
  }

  onPaymentCancel = cancel =>{

  }

  onPaymentPackageChange = (event, index, value) => {
    var money = this.state.money;
    money.total = value.Prezzo;
    money.currency = value.Valuta;
    money.Versione = value.Versione;
    money.selected = true;
    money.obj  = value;
    this.setState({ money: money });
  };

  componentDidMount = () => {

    this.props.dispatch(paymentConfig());
    
    this.props.dispatch(paymentPrices());
  }

  render(){
    
    return (<div>
            <Loader       isFetching      = {this.props.isFetching}      />
            <ErrorMessage message         = {this.props.errorMessage}    />
            <div style={styles.pageContainer}>
              <div style={styles.headerContainer}>
                <Stepper activeStep={this.state.activeStep} alternativeLabel>
                  {this.steps.map(label => {
                    return (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </div>

              <div style={styles.formContainer}>
                
                  <Paper zDepth={2} style={styles.paper}>
                    <div style={styles.paperTitle}>
                        {this.steps[this.state.activeStep]}
                    </div>
                      {/*DATI UTENTE*/}
                      {this.state.activeStep === 0 &&
                      <div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("userData", "username", event.target.value)}
                                hintText={LABEL_Enter_Username[USERLANGUAGE]}
                                floatingLabelText={LABEL_Username[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={ this.state.userData.usernameError || this.props.usernameError }
                                value={this.state.userData.username}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("userData", "email", event.target.value)}
                                hintText={LABEL_Enter_Email[USERLANGUAGE]}
                                floatingLabelText={LABEL_Email[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={ this.state.userData.emailError || this.props.userEmailError }
                                value={this.state.userData.email}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("userData", "password", event.target.value)}
                                hintText={LABEL_Enter_Password[USERLANGUAGE]}
                                floatingLabelText={LABEL_Password[USERLANGUAGE]}
                                fullWidth={true}
                                type="password"
                                errorText={this.state.userData.passwordError}
                                value={this.state.userData.password}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("userData", "confirmPassword", event.target.value)}
                                hintText={LABEL_Enter_Password[USERLANGUAGE]}
                                floatingLabelText={LABEL_PasswordOKConfirm[USERLANGUAGE]}
                                fullWidth={true}
                                type="password"
                                errorText={this.state.userData.confirmPasswordError}
                                value={this.state.userData.confirmPassword}/>
                        </div>
                      </div>}



                      {/*DATI FATTURAZIONE*/}
                      {this.state.activeStep === 1 &&
                      <div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "ragioneSociale", event.target.value)}
                                hintText={LABEL_Enter_BusinessName[USERLANGUAGE]}
                                floatingLabelText={LABEL_BusinessName[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={this.state.invoiceData.ragioneSocialeError}
                                value={this.state.invoiceData.ragioneSociale}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "piva", event.target.value)}
                                hintText={LABEL_Enter_Piva[USERLANGUAGE]}
                                floatingLabelText={LABEL_Piva[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={this.state.invoiceData.pivaError}
                                value={this.state.invoiceData.piva}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "indirizzo", event.target.value)}
                                hintText={LABEL_Enter_Address[USERLANGUAGE]}
                                floatingLabelText={LABEL_Address[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={this.state.invoiceData.indirizzoError}
                                value={this.state.invoiceData.indirizzo}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "citta", event.target.value)}
                                hintText={LABEL_Enter_City[USERLANGUAGE]}
                                floatingLabelText={LABEL_City[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={this.state.invoiceData.cittaError}
                                value={this.state.invoiceData.citta}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "provincia", event.target.value)}
                                hintText={LABEL_Enter_District[USERLANGUAGE]}
                                floatingLabelText={LABEL_District[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={this.state.invoiceData.provinciaError}
                                value={this.state.invoiceData.provincia}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "cap", event.target.value)}
                                hintText={LABEL_Enter_Cap[USERLANGUAGE]}
                                floatingLabelText={LABEL_Cap[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={this.state.invoiceData.capError}
                                value={this.state.invoiceData.cap}/>
                        </div>
                        <div style={styles.inputContainer}>
                          <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "email", event.target.value)}
                                hintText={LABEL_Enter_Email[USERLANGUAGE]}
                                floatingLabelText={LABEL_Email[USERLANGUAGE]}
                                fullWidth={true}
                                errorText={this.state.invoiceData.emailError}
                                value={this.state.invoiceData.email}/>
                        </div>

                      </div>}



                      {/*PAGAMENTO*/}
                      {this.state.activeStep === 2 &&
                      <div>
                          { this.state.paid.toDo &&
                            <div>
                              <div style={{margin:"0 auto", marginTop: "50px", width: "80%"}}>
                                <SelectField
                                  floatingLabelText={LABEL_ChooseVersione[USERLANGUAGE]}
                                  value={this.state.money.obj}
                                  onChange={this.onPaymentPackageChange}
                                  fullWidth={true}>
                                      { this.props.paypalPriceList && this.props.paypalPriceList.map( price => <MenuItem key={price.Versione} value={price} primaryText={price.Versione}/>  ) }
                                </SelectField>
                              </div>
                              {this.state.money.selected && 
                                <div style={{width:"100%", marginTop: "50px"}}>
                                  {/*<Grid>
                                    <Row>
                                      <Col sm12={4}></Col>
                                      <Col sm12={4}>
                                        <PaypalExpressBtn 
                                          env       = {this.props.paypalConfig.Environment} 
                                          client    = {this.props.paypalConfig.Client}
                                          currency  = {this.state.money.currency}
                                          total     = {this.state.money.total}
                                          onError   = {this.onPaymentError}
                                          onSuccess = {this.onPaymentSuccess}
                                          onCancel  = {this.onPaymentCancel} />
                                      </Col>
                                      <Col sm12={4}></Col>
                                    </Row>
                                  </Grid>*/}
                                  <div className="fit-content" style={{margin: "0 auto"}}>
                                    <PaypalExpressBtn 
                                        env       = {this.props.paypalConfig.Environment} 
                                        client    = {this.props.paypalConfig.Client}
                                        currency  = {this.state.money.currency}
                                        total     = {this.state.money.total}
                                        onError   = {this.onPaymentError}
                                        onSuccess = {this.onPaymentSuccess}
                                        onCancel  = {this.onPaymentCancel} />`
                                    </div>
                              </div>}
                            </div>}

                          { this.state.paid.success &&
                            <Row>
                              <Col sm12={4} style={{paddingLeft: "23px"}}><div className="checkmark"></div></Col>
                              <Col sm12={4} style={{color: "#4e87d8", fontSize: "53px", padding: "10px", paddingTop: "32px", paddingLeft: "23px"}}>Pagamento Effettuato</Col>
                            </Row>
                          }

                          { this.state.paid.error   && ""

                          }
                      </div>}    
                  </Paper>
                
              </div>

              <div style={styles.navButton}>
                <Grid>
                  <Row>
                    {this.state.paid.toDo && this.state.activeStep >0 && <Col sm12={3}><RaisedButton className="button-table" icon={<IconArrowBack />}  buttonStyle={STYLES.sg_Button} onClick={()=> this.backStep()}/></Col>}
                    <Col sm12={6}></Col>
                    <Col sm12={3}>
                      <RaisedButton className="button-table" icon={ (this.state.activeStep == this.steps.length-1) ? <IconCheck/> : <IconArrowForward />}  buttonStyle={STYLES.sg_Button} onClick={()=> this.nextStep()}/>
                    </Col>
                  </Row>
                </Grid>
                  
                  
              </div>
            </div>
        </div>);
  }
}

function mapStateToProps(state) {
  const { registrazioneReducer } = state;
  const { isFetching, errorMessage, usernameError, userEmailError, paypalConfig, paypalPriceList} = registrazioneReducer;
  return {
    isFetching,
    errorMessage,
    usernameError,
    userEmailError,
    paypalConfig,
    paypalPriceList
  };
}

export default connect(mapStateToProps)(Registrazione);


// WEBPACK FOOTER //
// ./src/Containers/Registrazione.js